<template>
	<!--模态框 弹框 可自主切换头部icon    -->
	<div class="model-container animated-5 fadeIn" :id="idOver" :class="classCpt">
		<div class="model-box posi-relative" :style="mdlStyle">
			<!-- 头部 标题 + 关闭  -->
			<p class="model-title flex-jf-btw">
				<!--标题-->
				<span class="mdl-title"> 
					<slot name="title">提示</slot> 
				</span>
				<!--关闭按钮-->
				<slot name="cancle"></slot>
			</p>
			<!-- 主要内容 -->
			<div class="model-content">
				<slot name="mdl-content"></slot>
				<div class="txt-center flex-jf-btw">
                    <slot>
                        <p class="btnP btn-cancle ccBtn" @click="confirmLinkTo($event)">取消</p>
                        <p class="btnP btn-Ok okBtn" @click="confirmLinkTo($event)">确定</p>
                        <!-- <btn-middle @click="confirmLinkTo($event)" classCpt="ccBtn btn-free">取消</btn-middle>
					    <btn-middle @click="confirmLinkTo($event)" classCpt="okBtn">确定</btn-middle> -->
                    </slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		inheritAttrs:false,//根元素不继承特性
		props:['widthCpt','id','classCpt'],
		mounted(){
			//如果设置了 左边距，则显示在组件中
			if(this.widthCpt > 0){
				this.mdlStyle = 'width:' + this.widthCpt + 'px;'
            }
            if(this.id){
                this.idOver = this.id;
            }
		},
		data(){
			return{
                mdlStyle:'',
                idOver:'confirmMsgBox'
			}
		},		 
		methods:{
			//跳转页面
			confirmLinkTo(e){
                let tmpModel = $(e.target).parent().parent().parent().parent();
                // 如果是 注册用户提示 开户
                if(tmpModel.find('#confirmMsgTip').html().indexOf('您已注册成功') > -1 ){
                    if(e.target.className.indexOf('btn-Ok') > -1){ 
                        this.$router.push({path:tmpModel.find('#confirmOkUrl').val()});
                    }
                }else if(tmpModel.find('#confirmMsgTip').html().indexOf('风险评测已过期') > -1 ){
                    if(e.target.className.indexOf('btn-Ok') > -1){ 
                        this.$router.push({path:tmpModel.find('#confirmOkUrl').val()});
                    }
                }else if(tmpModel.find('#confirmMsgTip').html().indexOf('不良诚信记录') > -1 ){
                    if(e.target.className.indexOf('btn-cancle') > -1){
                        let routeData = tmpModel.find('#confirmCCUrl').val();
                        window.open(routeData, '_blank'); 
                    }
                }else{ //
                    if(e.target.className.indexOf('btn-cancle') > -1){
                        let strUrl = tmpModel.find('#confirmCCUrl').val();  	
                        // this.$router.push({path:strUrl});
                        if(strUrl){
                            let routeData = this.$router.resolve({ path: strUrl });
                            window.open(routeData.href, '_blank');
                        }
                    }else if(e.target.className.indexOf('btn-Ok') > -1){
                        let strUrl = tmpModel.find('#confirmOkUrl').val();  	
                        // this.$router.push({path:strUrl});
                        if(strUrl){
                            let routeData = this.$router.resolve({ path: strUrl });
                            window.open(routeData.href, '_blank');
                        }
                    }
                }
                //隐藏 confirm 弹框
                tmpModel.hide();
				// this.$tools.hideConfirmMsg_model();
			}
		}
	}
</script>

<style scoped lang='less'>	
    #confirmMsgBox .mdl-btn-box{ margin-top:1.3rem; }
    #confirmMsgBox .mdl-btn-content{ top:3rem; }
    #confirmMsgBox .mdl-btn-content >p:first-child{ font-size: .8rem; color: #666;}
    #confirmMsgBox p.btnP{
        height:2.1rem;
        width: 7rem;
        line-height: 2.1rem;
        border-radius: .2rem;
        cursor: pointer;
        transition: all .2s;
    }
    #confirmMsgBox p.btn-cancle{
        color:#d20600;
        border:.05rem solid #d20600;
    }
    #confirmMsgBox p.btn-cancle:hover{
        background:#f1f1f1;
    }
    #confirmMsgBox p.btn-Ok{
        color:#fff;
        background: #d20600;
    }
    #confirmMsgBox p.btn-Ok:hover{
        background:#ff5f5a;
    }
</style>


// WEBPACK FOOTER //
// src/components/publicCpts/modelConfirmCpt.vue